import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import QRCode from 'qrcode';

const ClockInOut = (props) => {
  const [image, setImage] = useState();
  const [date, setDate] = useState(new Date());
  const [inorout, setinorout] = useState("Clocking IN");

  useEffect(() => {
      generateQRCode();
      setInterval(()=>{
        setDate(new Date());
        generateQRCode();
      },60000)
        // eslint-disable-next-line
  }, []);

  const generateQRCode = async ()=>{
      try{
          const date = new Date().toISOString() + " " + inorout
          const resp = await QRCode.toDataURL(date )
          setImage(resp)
      }catch(err){
          console.log(err)
      }
  }
  const clickIn = ()=>{
    setinorout("Clocking IN")
    generateQRCode();
  }
  const clickOut = ()=>{
    setinorout("Clocking OUT")
    generateQRCode();
  }
  return (
    <>
      <Container className="mt-7" fluid>
        <Row className="justify-content-center">
            <div >
                <h3 > Time : {date.toLocaleTimeString().split(":")[0] + ":" + date.toLocaleTimeString().split(":")[1] + " " + date.toLocaleTimeString().split(":")[2].split(" ")[1]}</h3>
                <h3> Date : {date.toLocaleDateString().split("/")[1] + "/" + date.toLocaleDateString().split("/")[0] + "/" + date.toLocaleDateString().split("/")[2]}</h3>
            </div>
        </Row>
        <Row background={"red"} >
          <Col lg="4" className="align-self-center">
            <Button onClick={clickOut} className="float-right btn-danger" style={{paddingTop: "30%" , paddingBottom: "30%"}} >
              <div >
                <i className="ni ni-bold-left" />
                <h4>Clock Out</h4>
              </div>
            </Button>
          </Col>
          <Col lg="4">
            <img src={image} alt="qrcode" width="100%" className="align-self-center" />
            <h3 className="text-center p-3" 
            style={{ backgroundColor:inorout === "Clocking OUT" ? "#f5365c" : "#11cdef"}}>{ inorout }</h3>
          </Col>
          <Col lg="4" className="align-self-center">
            <Button onClick={clickIn} className="btn-info" style={{paddingTop: "30%" , paddingBottom: "30%"}}>
              <div >
                <i className="ni ni-bold-right" />
                <h4>Clock In</h4>
              </div>
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ClockInOut;
